import React, { useState, useRef, useImperativeHandle } from 'react';
import { EditOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Tooltip, Button } from 'antd';
import PropTypes from 'prop-types';

import styles from './EditableInput.less';

const { TextArea } = Input;

export const EditableInput = (props) => {
  const { enableConfirmButtons } = props;
  const [value, setValue] = useState(props.value);
  const [editMode, setEditMode] = useState(!props.value);
  const inputEl = useRef(null);

  useImperativeHandle(inputEl, () => ({
    focus: () => {
      inputEl.current.focus();
    },
  }));

  const handleSave = () => {
    if (value !== props.value) {
      if (props.userId) {
        props.submitValue(props.userId, value);
      } else {
        props.submitValue(value);
      }
    }

    setEditMode(false);
  };

  const onBlur = () => {
    if (enableConfirmButtons) return;
    handleSave();
  };

  let contentJSX = '';
  if (!editMode) {
    contentJSX = (
      <div className={styles.readField}>
        <span onClick={() => !enableConfirmButtons && setEditMode((val) => !val)}>{value}</span>
        <Tooltip title="Edit">
          <a className={styles.editBtn} onClick={() => setEditMode((val) => !val)}>
            <EditOutlined />
          </a>
        </Tooltip>
      </div>
    );
  } else {
    contentJSX = (
      <>
        <TextArea
          ref={inputEl}
          placeholder="Insert..."
          autosize={{
            minRows: props.minRows || 2,
            maxRows: 6,
          }}
          onBlur={onBlur}
          onPressEnter={onBlur}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        {enableConfirmButtons && (
          <div className={styles.confirmBtns}>
            <Button
              icon={<CloseOutlined />}
              onClick={() => {
                setValue(props.value);
                setEditMode(false);
              }}
            />
            <Button type="primary" icon={<CheckOutlined />} onClick={handleSave} />
          </div>
        )}
      </>
    );
  }

  return (
    <Form.Item label={props.label} className={props.className}>
      {contentJSX}
    </Form.Item>
  );
};

EditableInput.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  minRows: PropTypes.number,
  userId: PropTypes.string,
  submitValue: PropTypes.func.isRequired,
  className: PropTypes.oneOf([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  enableConfirmButtons: PropTypes.bool.isRequired,
};

EditableInput.defaultProps = {
  className: '',
  enableConfirmButtons: false,
};
